import { defineStore, acceptHMRUpdate } from "pinia"

export const useOptionStore = defineStore("option", {
  state: () => ({
    units: [] as string[],
    taxRates: [] as string[],
    envelopes: ["Groceries", "Gas", "Hobbies", "Home Maintenance", "Luxuries"],
    accounts: ["QuickSilver", "Amazon Visa", "Chase Visa", "Discover", "Wallet"]
  }),
  getters: {},
  actions: {
    async refresh() {
      await this.refreshUnits()
      await this.refreshTaxRates()
    },
    async refreshUnits() {
      this.units = await this.pb.send("/api/units", {})
    },
    async refreshTaxRates() {
      this.taxRates = await this.pb.send("/api/taxRates", {})
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOptionStore, import.meta.hot))
}
